export enum ContractSelectionTypes {
  TICKET,
  CONSUMPTION,
}
